import { FC } from 'react';
import { useParams } from 'react-router';
import { useFlowInfo } from '@flows/src/api/getFlowInfo';
import FlowsConfigureFinish from './FlowsConfigureFinish';
import FlowsConfigureYellowhiveFinish from './FlowsConfigureYellowhiveFinish';
import LoadingSpinner from '@common/src/components/LoadingSpinner';

const FlowsConfigureFinishWrapper: FC = () => {
  const { flowId } = useParams<{ flowId: string }>();
  const { data: flowInfo, isLoading } = useFlowInfo(flowId || '');

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!flowInfo) {
    return <LoadingSpinner />;
  }

  const isYellowhiveFlow = flowInfo.sub_type === 'YELLOWHIVE';

  if (isYellowhiveFlow) {
    return <FlowsConfigureYellowhiveFinish />;
  }

  return <FlowsConfigureFinish />;
};

export default FlowsConfigureFinishWrapper;
